var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es296.js.map
